export const dateFormats = {
    slashMonthDayFullYear: {
        label: 'MM/DD/YYYY',
        value: 'MM/DD/YYYY'
    },
    slashMonthDayYear: {
        label: 'MM/DD/YY',
        value: 'MM/DD/YY'
    },
    dashMonthDayFullYear: {
        label: 'MM-DD-YYYY',
        value: 'MM-DD-YYYY'
    },
    dashMonthDayYear: {
        label: 'MM-DD-YY',
        value: 'MM-DD-YY'
    },
    slashDayMonthFullYear: {
        label: 'DD/MM/YYYY',
        value: 'DD/MM/YYYY'
    },
    slashDayMonthYear: {
        label: 'DD/MM/YY',
        value: 'DD/MM/YY'
    },
    dashDayMonthFullYear: {
        label: 'DD-MM-YYYY',
        value: 'DD-MM-YYYY'
    },
    dashDayMonthYear: {
        label: 'DD-MM-YY',
        value: 'DD-MM-YY'
    },
    slashYearMonthDay: {
        label: 'YYYY/MM/DD',
        value: 'YYYY/MM/DD'
    },
    dashYearMonthDay: {
        label: 'YYYY-MM-DD',
        value: 'YYYY-MM-DD'
    }
};